import { ArrowForwardIcon, CheckCircleIcon } from "@chakra-ui/icons";
import { Box, Button, Center, Divider, Heading, Image, List, ListIcon, ListItem, Text } from "@chakra-ui/react";
import { css, keyframes } from "@emotion/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../App.css'

const moveArrow = keyframes`
  0% { transform: translateX(0);}
  25% { transform: translateX(5px);}
  50% { transform: translateX(-5px);}
  75% { transform: translateX(5px);}
  100% { transform: translateX(0);}
`;

const moveBackground = keyframes `
from {background-position: 0 0;}
to {background-position: 100% 100%;}`;

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      ::-webkit-scrollbar {
        width: 8px;
      }
      ::-webkit-scrollbar-track {
        background: #1a202c; /* Chakra's blue.700 */
      }
      ::-webkit-scrollbar-thumb {
        background-color: #2b6cb0; /* Chakra's blue.500 */
        border-radius: 4px;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, [])

  const handleClick = () => {
    navigate("/info");
  };
   const animation = `${moveBackground} 10s linear infinite`;

  return (
    <Box  
    h='100vh'
    w='100vw'
    bgImage="url('/images/bg.jpg')"
    bgSize='cover'
    bgRepeat='no-repeat'
   animation={animation}
    position='relative'
    overflow='auto'
    // alignItems='center'
     // justifyContent='center'
    // display='flex'
    // flexDirection='column'
  
  
    >

 {/* Header Content */}
 <Box
        as="header"
        // borderBottom="2px solid white"
        p={2}
        pb={4} // Padding bottom for space between border and image
        textAlign="center"// Center text horizontally
        maxH={{base: '40%', sm:'40%', lg: "50%" }}
         bg="rgba(0,0,0,0.5)"
         maxW='100vw'
        
         clipPath= {{base: "polygon(0% 0%, 100% 0%, 100% 90%, 0% 100%)", md:"polygon(0% 0%, 100% 0%, 100% 80%, 50% 100%, 0% 80%)"}} 
      >
        {/* Logo and Header Text */}
        <Center className="mb-4"> {/* Use margin-bottom for space under the header */}
          <Box
            bg="blue.500"
            color="white"
            borderRadius="full"
            display="flex"
            flexDirection='column'
            alignItems="center"
            justifyContent="center"
            width="50px"
            height="50px"
            p={4}
            fontWeight="bold"
            fontSize="md"
            mr={2} // Margin-right for spacing between logo and text
           
          >
            CB
          </Box>
          <Heading as="h1" size={{base:"sm", md:'md'}} color="white">
            CB TECH SUPPORT TEAM
          </Heading>
        </Center>

        {/* Image Below */}
        <Image
          src="./images/index.png"
          alt="Tech Support"
          p={{base:8, md:40}}
minH={{ md: '30%'}}
mt={{md:-28}}
maxW={{base:'90%', lg:'70%'}}
          ml={{base:4, sm:50, lg:60}}
          // className="w-full h-auto"
        />


      </Box>
   <Box/>

   {/* subheading */}
   <Box  
   position='relative'
   top='-20px'
   w='100%'
   p={6}
   textAlign='center'
   >

   <Heading as="h2" size='md' color='white'
   mb={4}>
    Welcome To The Support Team Page
   </Heading>

<Box  
width='90%'
maxW='600px'
height='60'
mx='auto'
p={4}
bg=''
borderRadius='md'
boxShadow='0px 8px 20px rgba(0, 0, 0.3)'
textAlign='left'
justifyContent='s'

>
     {/* List with Blue Checkmarks */}
     <List spacing={0} 
     display='flex'
     flexDirection='column'
     justifyContent='space-between'
     height='100%'
     >
            <ListItem color='white' fontWeight={600}>
              <ListIcon as={CheckCircleIcon} color="blue.500" />
              Real time updates on status support requests.
            </ListItem>
            <ListItem color='white' fontWeight={600}>
              <ListIcon as={CheckCircleIcon} color="blue.500" />
              Personalized assistance tailored to your specific needs.
            </ListItem>
            <ListItem color='white' fontWeight={600}>
              <ListIcon as={CheckCircleIcon} color="blue.500" />
             Rapid response times.
            </ListItem>
            <ListItem color='white' fontWeight={600}>
              <ListIcon as={CheckCircleIcon} color="blue.500" />
              Ticket progress status report.
            </ListItem>
          </List>

</Box>

     </Box>
 {/* Button Fixed to the Bottom */}

        <Button position="fixed" bottom="0"
          width="100%"
          bg="#011082"
          color="white"
          size="md"
          _hover={{ bg: 'blue.400' }}
          _active={{ bg: 'blue.600' }}
          onClick={handleClick}
          
        >
          Get Support Now
        </Button>
      </Box>
   
  )
};

export default Home;